import { CollectionStore } from '../../../common/core/store/collection.store';
import { NodeWire } from '../../../external/server/node.wire';
import { MegaBoardContentWire } from '../board/mega/mega-board-content.wire';
import { BasicNodeSubWire } from './basic-node-sub.wire';

export const NodeStore = CollectionStore.create<NodeWire & { sub?: BasicNodeSubWire | MegaBoardContentWire }>();
